import { render, staticRenderFns } from "./novel_create_label.vue?vue&type=template&id=498843f8"
import script from "./novel_create_label.vue?vue&type=script&lang=js"
export * from "./novel_create_label.vue?vue&type=script&lang=js"
import style0 from "./novel_create_label.vue?vue&type=style&index=0&id=498843f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports